import { motion } from 'framer-motion'
import { Smartphone, Tablet, Monitor, ArrowDown } from 'lucide-react'

const HeroSection = () => {
  return (
    <section className="gradient-bg py-20 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-4xl lg:text-6xl font-bold text-dark-900 mb-6">
            Nossos Apps Especializados
          </h1>
          <p className="text-xl lg:text-2xl text-gray-600 mb-12 leading-relaxed">
            Cada app foi desenvolvido especificamente para atender às necessidades 
            únicas de alunos, professores e gestores de escolas de natação.
          </p>

          {/* App Icons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="flex justify-center items-center space-x-8 mb-12"
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-2xl flex items-center justify-center text-white">
                <Smartphone className="h-10 w-10" />
              </div>
              <span className="text-sm font-medium text-gray-700">App do Aluno</span>
            </div>
            
            <div className="flex flex-col items-center space-y-4">
              <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center text-white">
                <Tablet className="h-10 w-10" />
              </div>
              <span className="text-sm font-medium text-gray-700">App do Professor</span>
            </div>
            
            <div className="flex flex-col items-center space-y-4">
              <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl flex items-center justify-center text-white">
                <Monitor className="h-10 w-10" />
              </div>
              <span className="text-sm font-medium text-gray-700">App da Escola</span>
            </div>
          </motion.div>

          {/* Scroll Indicator */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col items-center space-y-2"
          >
            <span className="text-sm text-gray-500">Role para conhecer cada app</span>
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <ArrowDown className="h-6 w-6 text-gray-400" />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default HeroSection
